module.exports = __webpack_public_path__ + "static/media/Portrait-10259.4fab905c.jpg";